import { createContentfulComponent } from "frontend/contentful/lib/create-contentful-component";
import { TextCalloutEntry } from "frontend/contentful/schema/blocks";
import { TextCallout } from "design-system/components/blocks/text-callout/text-callout";
import { createTextCalloutProps } from "./text-callout.props";

export interface TextCalloutOptions {
  headerAbove?: boolean;
}

export const ContentfulTextCallout = createContentfulComponent<
  TextCalloutEntry,
  TextCalloutOptions
>(({ entry, options }) => {
  const props = createTextCalloutProps(entry, options);

  return <TextCallout {...props} />;
});
